/**
 * Opens and closes the PDP size chart drawer.
 */
(() => {
  const MODAL_ID = 'pdp-size-chart-modal';
  const BACKDROP_ID = 'pdp-size-chart-backdrop';
  const OPEN_SELECTOR = '[data-pdp-size-chart-open]';
  const CLOSE_SELECTOR = '[data-pdp-size-chart-close]';

  /**
   * Moves overlay elements to the document body so they stack above the sticky header.
   */
  const mountToBody = () => {
    const modal = document.getElementById(MODAL_ID);
    const backdrop = document.getElementById(BACKDROP_ID);

    if (!modal || !backdrop) return;

    if (modal.parentElement !== document.body) {
      document.body.append(modal);
    }

    if (backdrop.parentElement !== document.body) {
      document.body.append(backdrop);
    }
  };

  /**
   * @returns {{ modal: HTMLElement, backdrop: HTMLElement } | null}
   */
  const getElements = () => {
    mountToBody();

    const modal = document.getElementById(MODAL_ID);
    const backdrop = document.getElementById(BACKDROP_ID);

    if (!modal || !backdrop) return null;

    return { modal, backdrop };
  };

  const openSizeChart = () => {
    const elements = getElements();
    if (!elements) return;

    elements.modal.hidden = false;
    elements.backdrop.hidden = false;
    document.body.classList.add('overflow-hidden');
  };

  const closeSizeChart = () => {
    const elements = getElements();
    if (!elements) return;

    elements.modal.hidden = true;
    elements.backdrop.hidden = true;
    document.body.classList.remove('overflow-hidden');
  };

  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);

    if (target.closest(OPEN_SELECTOR)) {
      event.preventDefault();
      openSizeChart();
      return;
    }

    if (target.closest(CLOSE_SELECTOR)) {
      event.preventDefault();
      closeSizeChart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const elements = getElements();
    if (!elements || elements.modal.hidden) return;

    closeSizeChart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountToBody, { once: true });
  } else {
    mountToBody();
  }
})();
